import { render, staticRenderFns } from "./games-props-list.vue?vue&type=template&id=4a4e7733&scoped=true&"
import script from "./games-props-list.vue?vue&type=script&lang=js&"
export * from "./games-props-list.vue?vue&type=script&lang=js&"
import style0 from "./games-props-list.vue?vue&type=style&index=0&id=4a4e7733&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e7733",
  null
  
)

export default component.exports